// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { getIconPath } from '@tcp/core/src/utils';
import {
  CustomRankingContainer,
  RatingsWrapper,
  RatingStarOverlay,
  RatingStarGrey,
  RatingStarMain,
  ReviewsCount,
} from '@tcp/core/src/components/features/browse/BundleProduct/atoms/RatingsAndReviews/styles/RatingsAndReviews.style';
import SafeComponent from '@tcp/core/src/components/common/hoc/withErrorBoundary';

const RatingsAndReviews = ({ ratings, reviewsCount }) => {
  const reviewsCountNumber = Number(reviewsCount);
  const starsRatingWhite = getIconPath('stars-rating');

  return (
    <>
      {Number(ratings) > 0 && reviewsCountNumber > 0 && (
        <CustomRankingContainer className="custom-ranking-container">
          <RatingsWrapper>
            <span className="sr-only">{`Rating: ${Number(ratings)} out of 5 stars`}</span>
            <RatingStarOverlay className="rating-star-overlay" ratings={ratings} aria-hidden={true}>
              <RatingStarMain
                src={starsRatingWhite}
                title={`Product ratings - ${ratings}`}
                alt=""
                className="rating-star-main"
              />
            </RatingStarOverlay>
            <RatingStarGrey
              aria-hidden={true}
              src={starsRatingWhite}
              title="Product ratings"
              alt=""
              className="rating-star-grey"
              ratings={ratings}
            />
          </RatingsWrapper>
          <ReviewsCount
            component="span"
            fontFamily="secondary"
            fontSize="fs12"
            className="reviews-count"
          >
            <span className="sr-only">{`${reviewsCountNumber} reviews`}</span>
            <span aria-hidden={true}>{reviewsCountNumber}</span>
          </ReviewsCount>
        </CustomRankingContainer>
      )}
    </>
  );
};

RatingsAndReviews.propTypes = {
  ratings: PropTypes.string,
  reviewsCount: PropTypes.string,
};

RatingsAndReviews.defaultProps = {
  ratings: '',
  reviewsCount: '',
};

export default SafeComponent(RatingsAndReviews);
export { RatingsAndReviews as RatingsAndReviewsVanilla };
